import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { Ship } from '../../../Models/ship';
import { Vehicle } from '../../../Models/vehicle';
import { ApiService } from '../../../core/services/api.service';

@Component({
    selector: 'dialog-move-ship',
    templateUrl: './dialog-move-ship.component.html',
    styleUrls: ['./dialog-move-ship.component.scss']
})

export class DialogMoveShipComponent implements OnInit {
 
  vehicles: Vehicle[] = [];

  selectedVehicle: Vehicle;
  shipToMove: Ship;
    
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<DialogMoveShipComponent>,
    private apiService: ApiService) {
    this.getVehicles();
  }

  ngOnInit(): void {
    this.shipToMove = this.data;
    if (this.vehicles.length > 0)
      this.selectedVehicle = this.vehicles[0];
  }

  moveShip() {
    this.shipToMove.loadVehicle = this.selectedVehicle;
    //this.apiService.put('api/ship', this.shipToMove).subscribe((response: any) => {
    //  this.dialogRef.close(this.shipToMove);
    //});
    this.dialogRef.close(this.shipToMove);
  }

  getVehicles() {
    this.apiService.get('api/vehicle/findAll').subscribe((response: any) => {
      if (response.data) {
        this.vehicles = response.data;
        if (this.vehicles.length > 0)
          this.selectedVehicle = this.vehicles[0];
      }
    });
  }
}
